export function enableChat() {
  const messageInput = /** @type {HTMLFormElement | null} */ (
    document.getElementById('message-input')
  )
  if (messageInput) {
    messageInput.disabled = false
    messageInput.focus()
  }

  const sendButton = /** @type {HTMLFormElement | null} */ (
    document.getElementById('send-button')
  )
  if (sendButton) {
    sendButton.disabled = false
  }
}
